import {ProjectPhase} from '../types';

export const DEFAULT_PHASE_COLORS = [
    '#4F46E5', // Position 0: Indigo
    '#7C3AED', // Position 1: Purple
    '#DB2777', // Position 2: Pink
    '#DC2626', // Position 3: Red
    '#EA580C', // Position 4: Orange
    '#16A34A', // Position 5: Green
    '#0891B2', // Position 6: Cyan
    '#8B5CF6', // Position 7: Violet
    '#F59E0B', // Position 8: Amber
    '#10B981', // Position 9: Emerald
    '#3B82F6', // Position 10: Blue
    '#EF4444' // Position 11: Red variant
] as const;

/**
 * Gets the default color for a phase based on its position
 * @param position - The 0-based position of the phase in the project
 * @returns Hex color code string
 */
export const getDefaultPhaseColor = (position: number): string => {
    if (position < 0) {
        return DEFAULT_PHASE_COLORS[0]; // Fallback to first color
    }

    return DEFAULT_PHASE_COLORS[position % DEFAULT_PHASE_COLORS.length];
};

/**
 * Gets color for the next phase to be created
 * @param existingPhases - Array of phases that already exist
 * @returns Hex color code for the new phase
 */
export const getNextPhaseColor = (existingPhases: ProjectPhase[]): string => {
    return getDefaultPhaseColor(existingPhases.length);
};

/**
 * Converts a hex color code to rgba with specified opacity
 * @param hex - Hex color code (e.g., '#4F46E5')
 * @param alpha - Opacity value between 0 and 1
 * @returns RGBA color string (e.g., 'rgba(79, 70, 229, 0.3)')
 */
export const hexToRgba = (hex: string, alpha: number): string => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
